// extracted by mini-css-extract-plugin
export default {"grid":"multiLocation_grid__qHUay"};